// extracted by mini-css-extract-plugin
export default {"headerWrapper":"styles_headerWrapper__FUvRi","toolBar":"styles_toolBar__jWIV9","logo":"styles_logo__hTa5C","appName":"styles_appName__LPnuq"};